<ng-container *ngIf="block">
    <div class="container-card bg-brand-99 d-flex flex-column justify-content-between no-print">
        <div *ngIf="stringTaxonomies" class="container-card__category ls-label-small text-neutral-60 text-uppercase"
            [innerHTML]="stringTaxonomies"></div>
        <div>
            <div class="container-card__title">
                <a *ngIf="!isLinkEsternal && objTitle" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
                    <h3 class="ls-h3-item-title text-brand-10 cursor-pointer" [innerText]="objTitle.title"></h3>
                </a>
                <a *ngIf="isLinkEsternal && objTitle" [href]="objTitle.link">
                    <h3 class="ls-h3-item-title text-brand-10 cursor-pointer" [innerText]="objTitle.title"></h3>
                </a>
            </div>
            <a *ngIf="!isLinkEsternal && objTitle" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
                <div class="m-0 container-card__cta line-discover-with-icon">
                    <p class="ls-label-medium-semibold text-brand-40 text-uppercase"
                        [innerHTML]="'BLOCK.SAMPLE_CARD_ALLOGGI.FIND_OUT_MORE' | translate"></p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </a>
            <a *ngIf="isLinkEsternal && objTitle" [href]="objTitle.link">
                <div class="m-0 container-card__cta line-discover-with-icon">
                    <p class="ls-label-medium-semibold text-brand-40 text-uppercase"
                        [innerHTML]="'BLOCK.SAMPLE_CARD_ALLOGGI.FIND_OUT_MORE' | translate"></p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </a>
        </div>
    </div>
    <app-sample-print [taxonomy]="stringTaxonomies" [title]="objTitle.title"></app-sample-print>
</ng-container>